import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RuntimeError } from '../models/errors';
import { ForecastLocationSearch } from '../models/forecastlocationsearch';
import { PositionStack } from '../models/positionstack';
import { WeatherBit } from '../models/weatherbit';

@Injectable({
  providedIn: 'root'
})
export class ApiService {    
    baseUrl = '';
    key = '';

    constructor(protected http: HttpClient) { }   

    hasKey() {
        return this.key.length > 0;
    }    
}

@Injectable({
    providedIn: 'root'
})
export class WeatherBitApiService extends ApiService {
    override baseUrl = 'https://api.weatherbit.io/v2.0';
    override key = '913c46c78380480f89d111dff8789212';

    getCurrentForecast(latitude: number, longitude: number) {
        let url = `${this.baseUrl}/current?key=${this.key}&lat=${latitude}&lon=${longitude}&units=I`; 
        return this.http.get<WeatherBit.Current.Result>(url);           
    }  
    getDailyForecast(latitude: number, longitude: number) {
        let url = `${this.baseUrl}/forecast/daily?key=${this.key}&lat=${latitude}&lon=${longitude}&units=I`;         
        return this.http.get<WeatherBit.Daily.Result>(url);           
    } 
    async getForecast(latitude: number, longitude: number) {
        // Get current forecast
        let current = await this.getCurrentForecast(latitude, longitude).toPromise();
        if (current.count == 0 || current.data.length == 0) {
            throw new RuntimeError.ForecastError(`Aucun résultat de prévision actuel n'a été renvoyé pour la latitude: ${latitude}, longitude: ${longitude}`);
        }

        // Get daily forecast
        let daily = await this.getDailyForecast(latitude, longitude).toPromise();

        return {
            current: current.data[0],
            daily: daily.data
        };
    }              
}

@Injectable({
    providedIn: 'root'
})
export class PositionStackApiService extends ApiService {
    override baseUrl = 'http://api.positionstack.com/v1';
    override key = 'd395d05f4766d93d1d8900cb164056b1';

    getForwardSearch(search: string) {
        let url = `${this.baseUrl}/forward?access_key=${this.key}&query=${encodeURIComponent(search)}`; 
        return this.http.get<PositionStack.Result>(url);           
    }

    getReverseSearch(ipAddress: string): any;
    getReverseSearch(latitude: number, longitude: number): any;   
    getReverseSearch(param1: string | number, param2?: string | number): any {
        let search = '';
        if (param2 == null) {
            search = `${param1}`;
        } else {
            search = `${param1},${param2}`;
        }
        let url = `${this.baseUrl}/reverse?access_key=${this.key}&query=${search}&limit=1`; 
        // console.log(url);
        return this.http.get<PositionStack.Result>(url);           
    }  

    async getForecastLocation(type: ForecastLocationSearch.Type, options: ForecastLocationSearch.Options) {
        let observable!: Observable<PositionStack.Result>;
        switch(type) {
            case ForecastLocationSearch.Type.IP:
                observable = this.getReverseSearch(options.ipAddress || '');
                break;
            case ForecastLocationSearch.Type.GPS:
                observable = this.getReverseSearch(options.latitude || 0, options.longitude || 0);
                break;
        }
        let geocode = await observable.toPromise();
        // console.log(geocode);
        if (geocode.error != null) {
            throw new RuntimeError.ForecastLocationError(geocode.error.message, type);
        }  else if (!geocode.data || geocode.data.length == 0) {
            throw new RuntimeError.ForecastLocationError('Aucun résultat de prévision n\'a été renvoyé', type);
        }
        return geocode;
    }        
}